import { usePreferences } from '../providers/preferences-provider';

type NotificationSettings = {
    showAlertPopup: boolean;
    setShowAlertPopup: (value: boolean) => void;
    playAlertSound: boolean;
    setPlayAlertSound: (value: boolean) => void;
};

/**
 * Which alert notifications this browser shows, stored per device in the
 * preferences provider rather than on the account — a user may want the sound
 * on at their desk and off on a shared screen.
 */
export function useNotificationSettings(): NotificationSettings {
    const showAlertPopupKey = 'notifications.showAlertPopup';
    const playAlertSoundKey = 'notifications.playAlertSound';

    const { prefs, setPrefs } = usePreferences();

    const showAlertPopup = stringToBoolean(prefs[showAlertPopupKey], true);
    const playAlertSound = stringToBoolean(prefs[playAlertSoundKey], true);

    function setShowAlertPopup(value: boolean) {
        setPrefs(showAlertPopupKey, value.toString());
    }

    function setPlayAlertSound(value: boolean) {
        setPrefs(playAlertSoundKey, value.toString());
    }

    return {
        showAlertPopup,
        setShowAlertPopup,
        playAlertSound,
        setPlayAlertSound
    };
}

function stringToBoolean(
    value: string | undefined,
    defaultValue: boolean
): boolean {
    if (value === undefined) {
        return defaultValue;
    }
    return value === 'true';
}
